import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { BackToTop, Footer, NavItem, NavMenu, ToggleButton } from "../Inicio/styles";
import { ButtonSmokingContainer, SmokingAzules, SmokingGrises, SmokingNegros, SmokingsContainer, SmokingTintos, SmokingVerdes } from "./styles";

const Smokings = () => {
    const navigate = useNavigate();
    const [collapsed, setCollapsed] = useState(false);
    const location = useLocation();
    const [showButton, setShowButton] = useState(false);

    useEffect(() => {
                if(collapsed) {
                    document.body.style.overflow = "hidden";
                } else {
                    document.body.style.overflow = "auto";
                }
        
                return () => {
                    document.body.style.overflow = "auto";
                };
            }, [collapsed])
    

    useEffect(() => {
        const handleScroll = () => {
            if(window.scrollY > 300) {
                setShowButton(true);
            } else {
                setShowButton(false);
            }
        }

        window.addEventListener("scroll", handleScroll);

        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const scrollToTop = () => {
        window.scrollTo ({
            top: 0,
            behavior: "smooth"
        })
    }
    return(
        <>
            <SmokingsContainer>
                <p>Smokings</p>
                <ToggleButton collapsed={collapsed} onClick={() => setCollapsed(!collapsed)}>
                    {collapsed ? "✕" : "☰"}
                </ToggleButton>
                <NavMenu collapsed={collapsed}>
                    <NavItem
                        active = {location.pathname === "/"}
                        onClick={() => navigate("/")}
                    >
                        Inicio
                    </NavItem>

                    <NavItem
                        active = {location.pathname === "/trajes"}
                        onClick={() => navigate("/trajes")}
                    >
                        Trajes
                    </NavItem>

                    <NavItem
                        active = {location.pathname === "/smokings"}
                        onClick={() => navigate("/smokings")}
                    >
                        Smokings
                    </NavItem>

                    <NavItem
                        active = {location.pathname === "/togas"}
                        onClick={() => navigate("/togas")}
                    >
                        Togas
                    </NavItem>
                    <NavItem>
                        <a
                            href="/catalogo-trajes"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Catálogo
                        </a>
                    </NavItem>
                    <NavItem><a href="https://wa.me/5213311407070" target="_blank" rel="noopener noreferrer">Contacto</a></NavItem>
                </NavMenu>
            </SmokingsContainer>
            <ButtonSmokingContainer>
                
                <SmokingNegros onClick={() => navigate("/smokings/negros")}>
                    Ver Smokings negros
                </SmokingNegros>
                
                <SmokingAzules onClick={() => navigate("/smokings/azules")}>
                    Ver Smokings Azules
                </SmokingAzules>

                <SmokingTintos onClick={() => navigate("/smokings/tintos")}>
                    Ver Smokings tintos
                </SmokingTintos>

                <SmokingGrises onClick={() => navigate("/smokings/grises")}>
                    Ver Smokings grises
                </SmokingGrises>

                <SmokingVerdes onClick={() => navigate("/smokings/verdes")}>
                    Ver Smokings verdes
                </SmokingVerdes>
            </ButtonSmokingContainer>
            <Footer>
                <p>Eleganza Sartoriale</p>
                <p>Guadalajara, Jalisco</p>
                <div>
                    <a href="https://www.instagram.com/renta_de_trajes_mr?utm_source=qr&igsh=MW9pb2VwMnRmeW8zaw==">Intagram</a>
                    <a href="https://www.facebook.com/share/14WVJRCc3W4/">Facebook</a>
                    <a href="https://www.tiktok.com/@rentadetrajesmr?_r=1&_t=ZS-95BqJJ1lF7X">Tik Tok</a>
                </div>
                <div>
                    <p>© 2026 Renta de Trajes MR. Todos los derechos reservados.</p>
                </div>
            </Footer>
            {showButton && (
                <BackToTop onClick={scrollToTop}>
                    ▲
                </BackToTop>
            )}
        </>
    )
};

export default Smokings;